<template>
  <CModal class="modal__footer-empty" size="lg" :close-on-backdrop="false" :show="show" @update:show="closeModal">
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">Seo</span>
      </div>

      <CButtonClose @click="closeModal" />
    </template>

    <div class="subflow">
      <VSeoForm :seo="seo" :show="show" />
    </div>
  </CModal>
</template>

<script>
import {
  createStatisticalMixin,
  statisticalStore
} from '@/mixins/statisticalMixin'
import VSeoForm from "@/components/Forms/VSeoForm";
import { modalStore } from "@/mixins/modalsMixin";

export default {
  name: "TheSeoModal",

  components: {
    VSeoForm
  },

  data: () => {
    return {}
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    currentUser() {
      return this[authStore.getterTypes.GETTER_USER]
    },
    seo() {
      const seo = this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`];
      return seo
    }
  },
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>